import { variationText } from '../model-evaluation.const'
import { createEvaluationBox } from './createEvaluationBox'

export const VariationEvaluationBox = createEvaluationBox(variationText)
